// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container and Layout */
.MaterialLogDetails-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* Header */
.MaterialLogDetails-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px 0;
  border-bottom: 2px solid #e2e8f0;
}

.MaterialLogDetails-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.MaterialLogDetails-icon {
  font-size: 2rem;
}

.MaterialLogDetails-addButton {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.MaterialLogDetails-addButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.MaterialLogDetails-addButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.MaterialLogDetails-buttonIcon {
  font-size: 1.2rem;
  font-weight: bold;
}

/* Controls Section */
.MaterialLogDetails-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  gap: 20px;
  flex-wrap: wrap;
}

.MaterialLogDetails-searchContainer {
  flex: 1 1;
  max-width: 500px;
}

.MaterialLogDetails-searchWrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.MaterialLogDetails-searchInput {
  width: 100%;
  padding: 12px 45px 12px 45px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background-color: white;
  transition: all 0.3s ease;
}

.MaterialLogDetails-searchInput:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.MaterialLogDetails-searchIcon {
  position: absolute;
  left: 15px;
  color: #64748b;
  font-size: 1.1rem;
}

.MaterialLogDetails-clearButton {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.MaterialLogDetails-clearButton:hover {
  background-color: #f1f5f9;
  color: #ef4444;
}

.MaterialLogDetails-stats {
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

.MaterialLogDetails-count {
  background-color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

/* Loading */
.MaterialLogDetails-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #64748b;
  font-size: 1.1rem;
}

.MaterialLogDetails-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: MaterialLogDetails-spin 1s linear infinite;
}

@keyframes MaterialLogDetails-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Table */
.MaterialLogDetails-tableContainer {
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.MaterialLogDetails-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.MaterialLogDetails-table thead {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
}

.MaterialLogDetails-table th {
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.MaterialLogDetails-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #4b5563;
}

.MaterialLogDetails-row:hover {
  background-color: #f8fafc;
}

.MaterialLogDetails-srNo {
  font-weight: 600;
  color: #6b7280;
}

.MaterialLogDetails-billNo,
.MaterialLogDetails-vehicleNo {
  font-weight: 500;
  color: #1f2937;
}

.MaterialLogDetails-date,
.MaterialLogDetails-time {
  font-family: "Courier New", monospace;
  font-size: 0.9rem;
}

.MaterialLogDetails-qty {
  font-weight: 600;
  color: #059669;
}

.MaterialLogDetails-remark {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MaterialLogDetails-imageCell {
  text-align: center;
}

.MaterialLogDetails-viewButton {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 auto;
}

.MaterialLogDetails-viewButton:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.MaterialLogDetails-noData {
  text-align: center;
  padding: 40px;
  color: #9ca3af;
  font-style: italic;
  font-size: 1.1rem;
}

/* Form Overlay and Popup */
.MaterialLogDetails-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.MaterialLogDetails-popup {
  background-color: white;
  border-radius: 20px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.MaterialLogDetails-popupHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 30px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-radius: 20px 20px 0 0;
}

.MaterialLogDetails-popupHeader h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
}

.MaterialLogDetails-closeButton {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #64748b;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.MaterialLogDetails-closeButton:hover {
  background-color: #fee2e2;
  color: #ef4444;
}

/* Form */
.MaterialLogDetails-form {
  padding: 30px;
}

.MaterialLogDetails-formGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.MaterialLogDetails-formGroup {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.MaterialLogDetails-fullWidth {
  grid-column: 1 / -1;
}

.MaterialLogDetails-label {
  font-weight: 600;
  color: #374151;
  font-size: 0.95rem;
}

.MaterialLogDetails-input,
.MaterialLogDetails-textarea {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.MaterialLogDetails-input:focus,
.MaterialLogDetails-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  background-color: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.MaterialLogDetails-textarea {
  resize: vertical;
  min-height: 80px;
}

/* File Upload */
.MaterialLogDetails-fileUpload {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.MaterialLogDetails-fileInput {
  display: none;
}

.MaterialLogDetails-fileLabel {
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
  color: #374151;
  padding: 12px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 2px solid #d1d5db;
  display: flex;
  align-items: center;
  gap: 8px;
}

.MaterialLogDetails-fileLabel:hover {
  background: linear-gradient(135deg, #e5e7eb, #d1d5db);
  transform: translateY(-1px);
}

.MaterialLogDetails-fileName {
  color: #059669;
  font-weight: 500;
  font-size: 0.9rem;
}

/* Form Actions */
.MaterialLogDetails-formActions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.MaterialLogDetails-cancelButton {
  background-color: #f8fafc;
  color: #64748b;
  border: 2px solid #e2e8f0;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.MaterialLogDetails-cancelButton:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.MaterialLogDetails-submitButton {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.MaterialLogDetails-submitButton:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.MaterialLogDetails-submitButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Image Modal */
.MaterialLogDetails-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.MaterialLogDetails-modalContent {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.MaterialLogDetails-modalClose {
  position: absolute;
  top: -40px;
  right: 0;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.MaterialLogDetails-modalClose:hover {
  background: rgba(255, 255, 255, 0.3);
}

.MaterialLogDetails-fullImage {
  max-width: 100%;
  max-height: 100%;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

/* Responsive Design */
@media (max-width: 768px) {
  .MaterialLogDetails-container {
    padding: 15px;
  }

  .MaterialLogDetails-header {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }

  .MaterialLogDetails-title {
    font-size: 2rem;
    text-align: center;
  }

  .MaterialLogDetails-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .MaterialLogDetails-searchContainer {
    max-width: none;
  }

  .MaterialLogDetails-tableContainer {
    overflow-x: auto;
  }

  .MaterialLogDetails-table {
    min-width: 800px;
  }

  .MaterialLogDetails-popup {
    margin: 10px;
    max-height: 95vh;
  }

  .MaterialLogDetails-formGrid {
    grid-template-columns: 1fr;
  }

  .MaterialLogDetails-formActions {
    flex-direction: column;
  }

  .MaterialLogDetails-addButton {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .MaterialLogDetails-title {
    font-size: 1.5rem;
  }

  .MaterialLogDetails-table th,
  .MaterialLogDetails-table td {
    padding: 10px 8px;
    font-size: 0.85rem;
  }

  .MaterialLogDetails-popup {
    border-radius: 15px;
  }

  .MaterialLogDetails-form {
    padding: 20px;
  }
}

/* Print Button */
.MaterialLogDetails-actionButtons {
  display: flex;
  align-items: center;
  gap: 15px;
}

.MaterialLogDetails-printButton {
  background: linear-gradient(135deg, #059669, #047857);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
  white-space: nowrap;
}

.MaterialLogDetails-printButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
}

.MaterialLogDetails-printButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Print Styles */
@media print {
  /* Hide everything except the table */
  .MaterialLogDetails-header,
  .MaterialLogDetails-controls,
  .MaterialLogDetails-loading,
  .MaterialLogDetails-overlay,
  .MaterialLogDetails-modal {
    display: none !important;
  }

  /* Container styles for print */
  .MaterialLogDetails-container {
    padding: 0;
    margin: 0;
    background-color: white;
    max-width: none;
    min-height: auto;
  }

  /* Table container for print */
  .MaterialLogDetails-tableContainer {
    box-shadow: none;
    border: 1px solid #000;
    border-radius: 0;
    margin: 0;
    page-break-inside: avoid;
  }

  /* Table styles for print */
  .MaterialLogDetails-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  .MaterialLogDetails-table th {
    background-color: #f5f5f5 !important;
    border: 1px solid #000;
    padding: 8px 6px;
    font-weight: bold;
    text-align: left;
    font-size: 11px;
  }

  .MaterialLogDetails-table td {
    border: 1px solid #000;
    padding: 6px 4px;
    font-size: 10px;
    color: #000;
  }

  .MaterialLogDetails-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  .MaterialLogDetails-row:hover {
    background-color: inherit;
  }

  /* Print header */
  .MaterialLogDetails-container::before {
    content: "Material Log Details Report";
    display: block;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #000;
  }

  /* Print date */
  .MaterialLogDetails-container::after {
    content: "Printed on: " attr(data-print-date);
    display: block;
    font-size: 10px;
    text-align: right;
    margin-top: 10px;
    color: #666;
  }

  /* View button in print */
  .MaterialLogDetails-viewButton {
    background: none;
    color: #000;
    border: 1px solid #000;
    padding: 2px 6px;
    font-size: 8px;
    box-shadow: none;
  }

  .MaterialLogDetails-viewButton:hover {
    transform: none;
    box-shadow: none;
  }

  /* Ensure proper page breaks */
  .MaterialLogDetails-table {
    page-break-inside: auto;
  }

  .MaterialLogDetails-table tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  .MaterialLogDetails-table thead {
    display: table-header-group;
  }

  .MaterialLogDetails-table tfoot {
    display: table-footer-group;
  }

  /* No data message for print */
  .MaterialLogDetails-noData {
    text-align: center;
    font-style: italic;
    color: #666;
    font-size: 12px;
  }
}

/* Responsive adjustments for print button */
@media (max-width: 768px) {
  .MaterialLogDetails-actionButtons {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .MaterialLogDetails-printButton {
    width: 100%;
    justify-content: center;
  }

  .MaterialLogDetails-controls {
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .MaterialLogDetails-printButton {
    font-size: 0.9rem;
    padding: 10px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/MaterialLogDetails.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,4DAA4D;EAC5D,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,UAAU;AACV;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC;;;;;IAKE,wBAAwB;EAC1B;;EAEA,+BAA+B;EAC/B;IACE,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,wBAAwB;EAC1B;;EAEA,2BAA2B;EAC3B;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,sCAAsC;IACtC,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA,eAAe;EACf;IACE,6CAA6C;IAC7C,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":["/* Container and Layout */\n.MaterialLogDetails-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Header */\n.MaterialLogDetails-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px 0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.MaterialLogDetails-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.MaterialLogDetails-icon {\n  font-size: 2rem;\n}\n\n.MaterialLogDetails-addButton {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.MaterialLogDetails-addButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n.MaterialLogDetails-addButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.MaterialLogDetails-buttonIcon {\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n/* Controls Section */\n.MaterialLogDetails-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.MaterialLogDetails-searchContainer {\n  flex: 1;\n  max-width: 500px;\n}\n\n.MaterialLogDetails-searchWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.MaterialLogDetails-searchInput {\n  width: 100%;\n  padding: 12px 45px 12px 45px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background-color: white;\n  transition: all 0.3s ease;\n}\n\n.MaterialLogDetails-searchInput:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.MaterialLogDetails-searchIcon {\n  position: absolute;\n  left: 15px;\n  color: #64748b;\n  font-size: 1.1rem;\n}\n\n.MaterialLogDetails-clearButton {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  font-size: 1.2rem;\n  padding: 4px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.MaterialLogDetails-clearButton:hover {\n  background-color: #f1f5f9;\n  color: #ef4444;\n}\n\n.MaterialLogDetails-stats {\n  color: #64748b;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.MaterialLogDetails-count {\n  background-color: white;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n/* Loading */\n.MaterialLogDetails-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n  color: #64748b;\n  font-size: 1.1rem;\n}\n\n.MaterialLogDetails-spinner {\n  width: 24px;\n  height: 24px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #3b82f6;\n  border-radius: 50%;\n  animation: MaterialLogDetails-spin 1s linear infinite;\n}\n\n@keyframes MaterialLogDetails-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Table */\n.MaterialLogDetails-tableContainer {\n  background-color: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.MaterialLogDetails-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\n.MaterialLogDetails-table thead {\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\n}\n\n.MaterialLogDetails-table th {\n  padding: 16px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.MaterialLogDetails-table td {\n  padding: 14px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #4b5563;\n}\n\n.MaterialLogDetails-row:hover {\n  background-color: #f8fafc;\n}\n\n.MaterialLogDetails-srNo {\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.MaterialLogDetails-billNo,\n.MaterialLogDetails-vehicleNo {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.MaterialLogDetails-date,\n.MaterialLogDetails-time {\n  font-family: \"Courier New\", monospace;\n  font-size: 0.9rem;\n}\n\n.MaterialLogDetails-qty {\n  font-weight: 600;\n  color: #059669;\n}\n\n.MaterialLogDetails-remark {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.MaterialLogDetails-imageCell {\n  text-align: center;\n}\n\n.MaterialLogDetails-viewButton {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 auto;\n}\n\n.MaterialLogDetails-viewButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.MaterialLogDetails-noData {\n  text-align: center;\n  padding: 40px;\n  color: #9ca3af;\n  font-style: italic;\n  font-size: 1.1rem;\n}\n\n/* Form Overlay and Popup */\n.MaterialLogDetails-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.MaterialLogDetails-popup {\n  background-color: white;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.MaterialLogDetails-popupHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 30px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\n  border-radius: 20px 20px 0 0;\n}\n\n.MaterialLogDetails-popupHeader h3 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.MaterialLogDetails-closeButton {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #64748b;\n  padding: 8px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.MaterialLogDetails-closeButton:hover {\n  background-color: #fee2e2;\n  color: #ef4444;\n}\n\n/* Form */\n.MaterialLogDetails-form {\n  padding: 30px;\n}\n\n.MaterialLogDetails-formGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.MaterialLogDetails-formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.MaterialLogDetails-fullWidth {\n  grid-column: 1 / -1;\n}\n\n.MaterialLogDetails-label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.95rem;\n}\n\n.MaterialLogDetails-input,\n.MaterialLogDetails-textarea {\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background-color: #fafafa;\n}\n\n.MaterialLogDetails-input:focus,\n.MaterialLogDetails-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  background-color: white;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.MaterialLogDetails-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* File Upload */\n.MaterialLogDetails-fileUpload {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.MaterialLogDetails-fileInput {\n  display: none;\n}\n\n.MaterialLogDetails-fileLabel {\n  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);\n  color: #374151;\n  padding: 12px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  border: 2px solid #d1d5db;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.MaterialLogDetails-fileLabel:hover {\n  background: linear-gradient(135deg, #e5e7eb, #d1d5db);\n  transform: translateY(-1px);\n}\n\n.MaterialLogDetails-fileName {\n  color: #059669;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n/* Form Actions */\n.MaterialLogDetails-formActions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.MaterialLogDetails-cancelButton {\n  background-color: #f8fafc;\n  color: #64748b;\n  border: 2px solid #e2e8f0;\n  padding: 12px 24px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.MaterialLogDetails-cancelButton:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.MaterialLogDetails-submitButton {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.MaterialLogDetails-submitButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n.MaterialLogDetails-submitButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Image Modal */\n.MaterialLogDetails-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 20px;\n}\n\n.MaterialLogDetails-modalContent {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n}\n\n.MaterialLogDetails-modalClose {\n  position: absolute;\n  top: -40px;\n  right: 0;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.MaterialLogDetails-modalClose:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.MaterialLogDetails-fullImage {\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 12px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .MaterialLogDetails-container {\n    padding: 15px;\n  }\n\n  .MaterialLogDetails-header {\n    flex-direction: column;\n    gap: 20px;\n    align-items: stretch;\n  }\n\n  .MaterialLogDetails-title {\n    font-size: 2rem;\n    text-align: center;\n  }\n\n  .MaterialLogDetails-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .MaterialLogDetails-searchContainer {\n    max-width: none;\n  }\n\n  .MaterialLogDetails-tableContainer {\n    overflow-x: auto;\n  }\n\n  .MaterialLogDetails-table {\n    min-width: 800px;\n  }\n\n  .MaterialLogDetails-popup {\n    margin: 10px;\n    max-height: 95vh;\n  }\n\n  .MaterialLogDetails-formGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .MaterialLogDetails-formActions {\n    flex-direction: column;\n  }\n\n  .MaterialLogDetails-addButton {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialLogDetails-title {\n    font-size: 1.5rem;\n  }\n\n  .MaterialLogDetails-table th,\n  .MaterialLogDetails-table td {\n    padding: 10px 8px;\n    font-size: 0.85rem;\n  }\n\n  .MaterialLogDetails-popup {\n    border-radius: 15px;\n  }\n\n  .MaterialLogDetails-form {\n    padding: 20px;\n  }\n}\n\n/* Print Button */\n.MaterialLogDetails-actionButtons {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.MaterialLogDetails-printButton {\n  background: linear-gradient(135deg, #059669, #047857);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);\n  white-space: nowrap;\n}\n\n.MaterialLogDetails-printButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);\n}\n\n.MaterialLogDetails-printButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Print Styles */\n@media print {\n  /* Hide everything except the table */\n  .MaterialLogDetails-header,\n  .MaterialLogDetails-controls,\n  .MaterialLogDetails-loading,\n  .MaterialLogDetails-overlay,\n  .MaterialLogDetails-modal {\n    display: none !important;\n  }\n\n  /* Container styles for print */\n  .MaterialLogDetails-container {\n    padding: 0;\n    margin: 0;\n    background-color: white;\n    max-width: none;\n    min-height: auto;\n  }\n\n  /* Table container for print */\n  .MaterialLogDetails-tableContainer {\n    box-shadow: none;\n    border: 1px solid #000;\n    border-radius: 0;\n    margin: 0;\n    page-break-inside: avoid;\n  }\n\n  /* Table styles for print */\n  .MaterialLogDetails-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n  }\n\n  .MaterialLogDetails-table th {\n    background-color: #f5f5f5 !important;\n    border: 1px solid #000;\n    padding: 8px 6px;\n    font-weight: bold;\n    text-align: left;\n    font-size: 11px;\n  }\n\n  .MaterialLogDetails-table td {\n    border: 1px solid #000;\n    padding: 6px 4px;\n    font-size: 10px;\n    color: #000;\n  }\n\n  .MaterialLogDetails-table tbody tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n\n  .MaterialLogDetails-row:hover {\n    background-color: inherit;\n  }\n\n  /* Print header */\n  .MaterialLogDetails-container::before {\n    content: \"Material Log Details Report\";\n    display: block;\n    font-size: 18px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 2px solid #000;\n  }\n\n  /* Print date */\n  .MaterialLogDetails-container::after {\n    content: \"Printed on: \" attr(data-print-date);\n    display: block;\n    font-size: 10px;\n    text-align: right;\n    margin-top: 10px;\n    color: #666;\n  }\n\n  /* View button in print */\n  .MaterialLogDetails-viewButton {\n    background: none;\n    color: #000;\n    border: 1px solid #000;\n    padding: 2px 6px;\n    font-size: 8px;\n    box-shadow: none;\n  }\n\n  .MaterialLogDetails-viewButton:hover {\n    transform: none;\n    box-shadow: none;\n  }\n\n  /* Ensure proper page breaks */\n  .MaterialLogDetails-table {\n    page-break-inside: auto;\n  }\n\n  .MaterialLogDetails-table tr {\n    page-break-inside: avoid;\n    page-break-after: auto;\n  }\n\n  .MaterialLogDetails-table thead {\n    display: table-header-group;\n  }\n\n  .MaterialLogDetails-table tfoot {\n    display: table-footer-group;\n  }\n\n  /* No data message for print */\n  .MaterialLogDetails-noData {\n    text-align: center;\n    font-style: italic;\n    color: #666;\n    font-size: 12px;\n  }\n}\n\n/* Responsive adjustments for print button */\n@media (max-width: 768px) {\n  .MaterialLogDetails-actionButtons {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .MaterialLogDetails-printButton {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .MaterialLogDetails-controls {\n    gap: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialLogDetails-printButton {\n    font-size: 0.9rem;\n    padding: 10px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
